<template>
	<div>
		<div class="add-to-stream-section" style="background: rgb(235, 235, 235); float: left; width: 100%;">
			<div class="header">
				<span id="titleSection">My Planning Streams</span>
        		<span v-if="!isPlanningStreamLocked && isPlannerViewEnabled" @click.stop.prevent="showPlannerDropDownClicked" class="fa fa-ellipsis-v"></span>
        		<div id="plannerDropDown" class="planner-dropdown-section"></div>
		        <b-popover v-if="!isPlanningStreamLocked && isPlannerViewEnabled" ref='popover' target="titleSection" container="plannerDropDown" :show.sync='showDropDown' :no-fade='true' placement="bottom" style="margin-left: 75px !important;">
		          <template slot="title">
  						<div class="header-title header-content-row">
  							<span class="title">Planning/Schedule</span>
		            <button class="btn_close" @click="showDropDown = false">
									<span class="ic-close"></span>
								</button>
  						</div>
  					</template>
		          <div>

		            <div class="content-sec">
		              <b-input-group>
		              	<div class="row cont-row">
		              		<div class="col-5 label-col">
			                	<label class="label" for="academicYear">Academic Year</label>
			                </div>
			                <div class="col-7">
				                <select id="academicYear" v-model="planningYear">
				                  <option v-for="academicYear in academicYears">
				                    {{ academicYear }}
				                  </option>
				                </select>
				             </div>
                   </div>
		              </b-input-group>
		              <div class="footer-row">
		              	<button class="btn close-btn" aria-label="goToPlanner" @click="goToPlanner" :disabled="isPlanningStreamNull || !planningYear || planningYear === 'ALL' || planningYear.startsWith('Any')">
		                  go to {{plannerViewLabel}}
		                </button>
		              </div>
		            </div>
		          </div>
		        </b-popover>
			</div>

			<div class="add-to-stream-list">
				<b-form-select v-model="selectedStreamUuid" :options="userStreams" aria-label="select planning stream" style="width: 81%; margin-left: 3%;" />
			</div>

			<div class="content-section">

				<div v-for="subStream in formattedPlanningStream">
		          <div class="sub-heading">
		            {{subStream.title}}:
		          </div>
		          <div class="course-list-column">
		            <div class="course-list-section" v-for="course in subStream.courses">
		              <div class="data-row">
		                <span class="title">{{course.title}}</span>
		                <b-btn :disabled.sync="isPlanningStreamLocked" @click="removeButtonClicked(course)" class="delete-btn" aria-label="remove">
                      x
                    </b-btn>
		              </div>
		            </div>
		            <button v-if="isScheduleCheckEnabled && hasCourses(subStream)" aria-label="check schedule" class="btn check-schedule"
		              @click="goToCalendarView(subStream)"
		              :disabled.sync="isPlanningStreamLocked || !subStream.courses.length || subStream.courses.length <= 0">
		              check schedule
		            </button>
		          </div>
			</div>

			</div>
			<div class="pagination-row btn_container pagination_sty3">
				<button class="btn btn_trans" :disabled="streamIndex === 0" @click="prev" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
				<button class="btn btn_trans" :disabled="isLastPage || (Object.keys(coursePlanningStream).length <= MAX_SUBSTREAM_COUNT)" @click="next" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
			</div>

		</div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'

  export default {
    name: 'add-to-stream',
    components: {

    },
    data: () => {
      return {
        userId: {},
        userRole: localStorage.getItem('userrole'),
        selectedStream: {},
        selectedStreamUuid: '',
        currentSemester: '',
        currentYear: '',
        defaultSemester: '',
        defaultYear: '',
        streamUuid: {},
        MAX_SUBSTREAM_COUNT: 3,
        SCROLL_SIZE: 3,
        streamIndex: 0,
        showDropDown: false,
        planningYear: '',
        lockStreamFlagName: 'lockStream'
      }
    },
    mounted () {
      this.userId = localStorage.getItem('userid')
      this.currentSemester = (this.semester) ? (this.semester.split(' ')[0]) : this.defaultSemester
      this.currentYear = (this.semester) ? (this.semester.split(' ')[1]) : this.defaultYear
      this.loadData()
    },
    methods: {
      ...mapActions([
        'populateCourses',
        'populateAllStreamCourses',
        'populateStreamsForUser',
        'populateCoursePlanningStream',
        'removeCourseFromStream',
        'updateSelectedStream',
        'addStreamCourse',
        'clearCourses',
        'loadLogDashboardActivity',
        'updateSearchAcademicYear'
      ]),
      loadData () {
        this.populateStreamsForUser({userId: this.userId}).then(results => {
          this.selectDefaultStream(results)
          this.populateAllStreamCourses({streamUuid: this.selectedStreamUuid})
          this.$forceUpdate()
        })

        // Have the first displayed substream match the search criteria for "Semester"
        this.streamIndex = this.calculateStartIndex()

        // Default selected academicYear for institutions that have this enabled
        let academicYears = this.academicYears
        if (academicYears && academicYears.length > 0) {
          this.planningYear = academicYears[0]
        }
        this.$forceUpdate()
      },
      reloadCourses () { // NOTE: this reloads coursePlanningPackage and sets the streamIndex to last added course
        return this.populateAllStreamCourses({streamUuid: this.selectedStreamUuid}).then(response => {
          this.streamIndex = this.calculateStartIndex()
        })
      },
      notifySuccess (text) {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: text
        })
      },
      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      },
      removeButtonClicked (course) {
        let streamUuid = this.selectedStreamUuid
        let semesterMap = this.semesterMap
        let currentSemester = semesterMap[course.termCode] ? semesterMap[course.termCode].split(' ')[0] : ''
        let currentYear = semesterMap[course.termCode] ? semesterMap[course.termCode].split(' ')[1] : ''

        // remove stream structure on Khub
        const params = {
          streamUuid: streamUuid,
          currentYear: currentYear,
          currentSemester: currentSemester,
          courseData: { uuid: course.uuid },
          userRole: this.userRole
        }
        this.removeCourseFromStream(params).then(response => {
          if (!response) {
            return
          }
          this.populateAllStreamCourses({streamUuid: this.selectedStreamUuid})
          this.$forceUpdate()
          this.notifySuccess('Successfully removed \'' + course.title + '\' from your stream.')
        })
      },
      streamSelected () {
        let streamUuid = this.selectedStreamUuid
        if (!streamUuid) {
          return
        }
        this.streamIndex = this.calculateStartIndex()
        this.clearCourses()
        this.populateAllStreamCourses({streamUuid: streamUuid})
        this.$forceUpdate()
      },
      goToCalendarView (substream) {
        this.loadLogDashboardActivity({action: 'checkSchedule', page: 'courseResults', link: 'check schedule'})
        let streamUuid = this.selectedStreamUuid
        let currentSemester = (substream && substream.title) ? substream.title.split(' ')[0] : this.currentSemester
        let currentYear = (substream && substream.title) ? substream.title.split(' ')[1] : this.currentYear
        this.updateSearchAcademicYear({academicYear: substream.academicYear})
        this.populateCourses({streamUuid: streamUuid, currentYear: currentYear, currentSemester: currentSemester}).then(response => {
          return this.$router.push({ name: 'semesterCalendarView', params: {streamUuid: streamUuid, currentYear: currentYear, currentSemester: currentSemester} })
        })
      },
      selectDefaultStream (results) {
        if (!results || !results.length || results.length <= 0) {
          return
        }
        let userId = this.userId
        let defaultSet = false
        let streamUuid
        results.forEach((stream) => {
          if (!defaultSet && stream.entityType !== 'club' && stream.entityType !== 'event' && stream.ownerId === userId) {
            streamUuid = stream.uuid
            defaultSet = true
          }
        })
        if (defaultSet) {
          this.selectedStreamUuid = streamUuid
        } else {
          // there is no stream that the user has access to, clearing this here to prevent
          // issues where a stream is deleted on KO side.
          this.selectedStreamUuid = {}
        }
        this.clearCourses()
      },
      createStreamClicked () {
        window.location.href = '/stream/create.html'
      },
      prev () {
        this.streamIndex -= this.SCROLL_SIZE
        if (this.streamIndex < 0) {
          this.streamIndex = 0
        }
      },
      next () {
        this.streamIndex += this.SCROLL_SIZE
        if (this.isLastPage) {
          this.streamIndex = Object.keys(this.coursePlanningStream).length - this.MAX_SUBSTREAM_COUNT
        }
      },
      calculateStartIndex () {
        let startIndex = 0
        let coursePlanningStream = this.coursePlanningStream
        let termCode = this.planningTermCode
        let academicYear = this.academicYear

        if (termCode) {
          Object.keys(coursePlanningStream).sort().forEach((key, i) => {
            let substream = coursePlanningStream[key]
            if (!substream || !substream.length || !substream.length === 0) {
              return
            }
            startIndex = (substream[0].termCode === termCode) ? i : startIndex
          })
        } else if (academicYear) {
          let isFound = false
          Object.keys(coursePlanningStream).sort().forEach((key, i) => {
            let currentYear = key.includes('_') ? key.split('_')[0] : ''
            if (!isFound && currentYear === academicYear) {
              isFound = true
              startIndex = i
            }
          })
        }
        return startIndex
      },
      showPlannerDropDownClicked () {
        this.showDropDown = true
      },
      goToPlanner () {
        let streamUuid = this.selectedStreamUuid
        let currentSemester = this.currentSemester
        let currentYear = this.currentYear
        let planningYear = this.planningYear
        return this.$router.push({ name: 'semesterPlannerView', params: {streamUuid: streamUuid, academicYear: planningYear, currentSemester: currentSemester, currentYear: currentYear} })
      },
      getCoursePlanningPackage () {
        let packages = this.packages
        if (!packages || !packages.length || packages.length <= 0) {
          return {}
        }
        return PackageUtil.getCoursePlanningPackage(packages)
      },
      hasCourses (stream) {
        return stream.courses && stream.courses.length > 0
      }
    },
    computed: {
      ...mapState({
        'lastUpdatedTime': state => state.semester.lastUpdatedTime,
        'courses': state => state.semester.courses,
        'iCalFile': state => state.semester.iCalFile,
        'streams': state => state.semester.streams,
        'coursePlanningStream': state => state.semester.coursePlanningStream,
        'semester': state => state.advancedSearch.semester,
        'planningTermCode': state => state.advancedSearch.planningTermCode,
        'termCode': state => state.advancedSearch.termCode,
        'academicYear': state => state.advancedSearch.academicYear,
        'packages': state => state.institution.packages,
        'institution': state => state.institution.institution,
        'enabledFeatures': state => state.institution.enabledFeatures
      }),
      advisorDashboardFeature () {
        return this.enabledFeatures[PACKAGE.FEATURE_IDS.ADVISTOR_DASHBOARD_FEATURE_ID]
      },
      isLockStreamEnabled () {
        let advisorDashboardFeature = this.advisorDashboardFeature
        if (!advisorDashboardFeature || !advisorDashboardFeature.enabled) {
          return false
        }
        let lockStreamFlag = PackageUtil.getFlagFromFeature(advisorDashboardFeature, this.lockStreamFlagName)
        if (!lockStreamFlag) {
          return false
        }
        return lockStreamFlag.enabled || lockStreamFlag.isEnabled
      },
      isPlannerViewEnabled () {
        let plannerViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PLANNER_VIEW_FEATURE_ID]
        if (plannerViewFeature && plannerViewFeature.enabled) {
          return true
        }
        return false
      },
      plannerViewLabel () {
        let label = 'year view'
        let plannerViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PLANNER_VIEW_FEATURE_ID]
        if (plannerViewFeature && plannerViewFeature.enabled && plannerViewFeature.label) {
          label = plannerViewFeature.label
        }
        return label.toLowerCase()
      },
      planningStream () {
        // NOTE: This assumes a user's planningStream exists and is the first entry in the list
        //       This will be true when a student is uploaded via CSV with the planStream column set
        let streams = this.userStreams
        if (!streams || !streams.length) {
          return {}
        }
        return streams[0]
      },
      isPlanningStreamNull () {
        let planningStream = this.planningStream
        return !planningStream || !planningStream.uuid
      },
      isPlanningStreamLocked () {
        if (!this.isLockStreamEnabled || this.isPlanningStreamNull) {
          return false
        }
        let planningStream = this.planningStream
        return planningStream.isLocked || planningStream.locked
      },
      formattedCourses () {
        let formattedCourses = []
        let courses = this.courses
        if (!courses) {
          return []
        }
        courses.forEach(function (course) {
          // TODO any processing here or remove if not needed
          formattedCourses.push(course)
        })
        return formattedCourses
      },
      userStreams () {
        let userId = this.userId
        let streams = this.streams
        let userStreams = []
        streams.forEach(stream => {
          if (stream.streamType && stream.entityType !== 'club' && stream.entityType !== 'event' && stream.ownerId === userId) {
            userStreams.push({
              value: stream.uuid,
              uuid: stream.uuid,
              text: stream.title,
              isLocked: stream.isLocked === true || stream.locked
            })
          }
        })
        return userStreams
      },
      formattedPlanningStream () {
        let formattedStream = []
        let numberOfSubstreams = 0
        let streamIndex = this.streamIndex
        let semesterMap = this.semesterMap
        let MAX = this.MAX_SUBSTREAM_COUNT
        let coursePlanningStream = this.coursePlanningStream

        Object.keys(coursePlanningStream).sort().forEach((key, i) => {
          if (i >= streamIndex && numberOfSubstreams < MAX) {
            let substream = coursePlanningStream[key]
            let courses = []
            let substreamLabel = key
            substream.forEach(course => {
              let courseData = course.course
              if (courseData) {
                courses.push({uuid: courseData.uuid, title: courseData.title, termCode: course.termCode})
                if (course && course.termCode) {
                  substreamLabel = semesterMap[course.termCode]
                }
              }
            })
            let academicYear = key.includes('_') ? key.split('_')[0] : ''
            formattedStream.push({title: substreamLabel, courses: courses, academicYear: academicYear})
            numberOfSubstreams += 1
          }
        })
        return formattedStream
      },
      featureMap () {
        let featureId = PACKAGE.FEATURE_IDS.SCHEDULE_CHECK_FEATURE_ID
        let coursePlanningPackage = this.getCoursePlanningPackage()
        return PackageUtil.getFeatureFromPackage(coursePlanningPackage, featureId)
      },
      scheduleCheckFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.SCHEDULE_CHECK_FEATURE_ID
        let coursePlanningPackage = this.getCoursePlanningPackage()
        return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
      },
      semesterMap () {
        let institution = this.institution
        if (!institution || !institution.semesterMap) {
          return {}
        }
        return institution.semesterMap
      },
      academicYears () {
        let institution = this.institution
        if (!institution || !institution.yearMap) {
          return {}
        }
        return Object.keys(institution.yearMap)
      },
      isLastPage () {
        let coursePlanningStream = this.coursePlanningStream
        let streamIndex = this.streamIndex
        let numberOfSubstreams = Object.keys(coursePlanningStream).length
        if (!streamIndex || !coursePlanningStream || !Object.keys(coursePlanningStream)) {
          return false
        } else if (numberOfSubstreams <= this.MAX_SUBSTREAM_COUNT) {
          return true
        }
        return streamIndex >= numberOfSubstreams - this.MAX_SUBSTREAM_COUNT
      },
      isScheduleCheckEnabled () {
        let featureMap = this.featureMap
        return featureMap && featureMap.enabled === true
      }
    },
    watch: {
      selectedStreamUuid (newId) {
        // TODO execute new search here after the stream is selected
        this.streamSelected()
        this.updateSelectedStream({streamUuid: newId})
      },
      semester (newSemester) {
        if (newSemester) {
          let terms = newSemester.split(' ')
          this.currentSemester = terms[0]
          this.currentYear = terms[1]
          this.streamSelected()
        }
      },
      planningTermCode (newCode) {
        this.reloadCourses()
      },
      lastUpdatedTime (timestamp) {
        this.reloadCourses()
      }
    }
  }
</script>

<style scoped>
#go-to-calendar-drop-down {
  float: right;
}

.add-to-stream {

}
 .year_view_link {
 	width: 100%;
 	float: left;
 	text-align: right;
 	padding-right: 5px;
 	margin-top: 20px;
 }
  .year_view_link a {
	color: #157099;
 }
 .year_view_link a:hover {
	color: #b78b10;
 }
</style>



// WEBPACK FOOTER //
// src/app/search/components/AddToStream.vue